import { all, put, call, takeLatest, takeEvery } from 'redux-saga/effects';
import * as actions from 'reducer/actionTypes'
import * as api from 'script/api'
import { isEmpty } from 'script/common';

export default function* fetchSetting() {

	yield all([
		takeEvery(actions.FETCH_GET_SETTING_DATA_INFO_REQUEST, getSettingDataInfo),
		takeLatest(actions.FETCH_GET_SETTING_ADDTIONAL_LIST_REQUEST, getSettingAdditionalList),
		takeLatest(actions.FETCH_GET_SETTING_ADDITIONAL_DEFAULT_KEY_INFO_REQUEST, getSettingAdditionalDefaultKeyInfo),
		takeLatest(actions.FETCH_SET_SETTING_DATA_UPDATE_REQUEST, setSettingDataUpdate),
		takeLatest(actions.FETCH_SET_SETTING_REDIS_MODE_UPDATE_REQUEST, setSettingRedisModeUpdate),
		takeLatest(actions.FETCH_SET_SETTING_ADDITIONAL_DATA_REQUEST, setSettingAdditionalData),
		takeLatest(actions.FETCH_SET_UI_CUSTOMIZATION_REQUEST, setUICustomization),
		takeLatest(actions.FETCH_GET_UI_CUSTOMIZATION_REQUEST, getUICustomization),
		takeLatest(actions.FETCH_WEBFONT_UPLOAD_REQUEST, uploadWebFont),
		takeLatest(actions.FETCH_WEBFONT_LIST_REQUEST, getWebFontList),
		takeLatest(actions.FETCH_WEBFONT_DELETE_REQUEST, deleteWebFont)
	])
}

function* getSettingDataInfo(params) {
	try {
		let result = null;

		if (isEmpty(params.keyList)) {
			result = yield call(api.getSettingData, params);
		} else {
			result = yield call(api.getSettingDataByKeyList, params);
		}

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
		} else {
			yield put({
				type: actions.FETCH_GET_SETTING_DATA_INFO_SUCCESS,
				key: params.key,
				value: result.data.value,
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put({
			type: actions.FETCH_GET_SETTING_DATA_INFO_FAILURE,
			error: error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* getSettingAdditionalDefaultKeyInfo(params) {
	try {
		const result = yield call(api.getSettingAdditionalDefaultKey, params);

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
		} else {
			yield put({
				type: actions.FETCH_GET_SETTING_ADDITIONAL_DEFAULT_KEY_INFO_SUCCESS,
				key: result.data.key,
				value: result.data.value,
				dataType: result.data.dataType,
				row: params.row
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put({
			type: actions.FETCH_GET_SETTING_DATA_INFO_FAILURE,
			error: error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* getSettingAdditionalList(params) {
	try {
		const result = yield call(api.getSettingAdditional, params);

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
		} else {
			yield put({
				type: actions.FETCH_GET_SETTING_ADDTIONAL_LIST_SUCCESS,
				value: result.data.value,
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put({
			type: actions.FETCH_GET_SETTING_ADDTIONAL_LIST_FAILURE,
			error: error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* setSettingDataUpdate(params) {
	try {
		const result = yield call(api.setSettingData, params);

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
		} else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.saved",
				isError: false
			})
			// reload
			yield put(params.reload)
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* setSettingRedisModeUpdate(params) {
	try {
		const result = yield call(api.setSettingRedisMode, params);

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
		} else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.saved",
				isError: false
			})
			// reload
			yield put(params.reload)
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* setSettingAdditionalData(params) {
	try {
		const result = yield call(api.setSettingAdditionalData, params);

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
		} else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.saved",
				isError: false
			})
			// reload
			yield put(params.reload)
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* setUICustomization(params) {
	try {
		const result = yield call(api.setUICustomization, params);

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			});
		} else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.saved",
				isError: false
			});	
			yield put({ type: actions.FETCH_GET_UI_CUSTOMIZATION_REQUEST });
		}
	} catch (error) {
		console.error("Error details:", error.response ? error.response.data : error.message);
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.response ? error.response.data : error.message,
			isError: true
		});
	} finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		});
	}
}

function* getUICustomization(params) {
	try {
		// API 호출 (GET 요청)
		const response = yield call(api.getUICustomization, params);
		const customizationData = response.data.value;
		// 요청이 성공하면 Redux에 성공 액션 디스패치
		yield put({
			type: actions.FETCH_GET_UI_CUSTOMIZATION_SUCCESS,
			value: customizationData, // 서버로부터 받은 데이터를 payload로 전달
		});
	} catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put({
			type: actions.FETCH_GET_UI_CUSTOMIZATION_FAILURE,
			error: error.message
		})
	} finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		});
	}
}

function* uploadWebFont(params) {
	try {
		const result = yield call(api.uploadWebFont, params);

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			});
		} else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.saved",
				isError: false
			});
			yield put({
				type: actions.FETCH_WEBFONT_UPLOAD_SUCCESS,
				value: result.data.value
			});
			// 업로드 후 목록 자동 재로드
			yield put({ type: actions.FETCH_WEBFONT_LIST_REQUEST });
		}
	} catch (error) {
		console.error("Error details:", error.response ? error.response.data : error.message);
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.response ? error.response.data : error.message,
			isError: true
		});
		yield put({
			type: actions.FETCH_WEBFONT_UPLOAD_FAILURE,
			error: error.message
		});
	} finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		});
	}
}

function* getWebFontList(params) {
	try {
		const response = yield call(api.getWebFontList, params);
		const webFontData = response.data.value;

		yield put({
			type: actions.FETCH_WEBFONT_LIST_SUCCESS,
			value: webFontData
		});
	} catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		});
		yield put({
			type: actions.FETCH_WEBFONT_LIST_FAILURE,
			error: error.message
		});
	} finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		});
	}
}

function* deleteWebFont(params) {
	try {
		const result = yield call(api.deleteWebFont, params);

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			});
		} else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.deleted",
				isError: false
			});
			yield put({
				type: actions.FETCH_WEBFONT_DELETE_SUCCESS
			});
			// 삭제 후 목록 자동 재로드
			yield put({ type: actions.FETCH_WEBFONT_LIST_REQUEST });
		}
	} catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		});
		yield put({
			type: actions.FETCH_WEBFONT_DELETE_FAILURE,
			error: error.message
		});
	} finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		});
	}
}

